import { createApi } from '@/api/modules/utils'

const baseUrl = '/material/image'
const api = createApi(baseUrl)

// 用户相关API
export const materialImageApi = {
  list: api('list', 'get'),
  insert: api('insert', 'post'),
  update: api('update', 'post'),
  delete: api('delete', 'get'),
  select: api('select', 'get'),
  selectByTag: api('select_by_tag', 'get'),
  selectByClassify: api('select_by_classify', 'get'),
}